import { Box, styled } from "@mui/material";
import { Typography } from "@pmag/ui-components";

export const Card = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    borderRadius: theme.shape.borderRadius,
    height: "138px",
    maxWidth: "350px",
    boxShadow: theme.shadow.boxShadow.sm,
    userSelect: "none",
    overflow: "hidden",

    "&:hover": {
        boxShadow: theme.shadow.boxShadow.lg,
        cursor: "pointer",
    },
}));

export const ImageContent = styled(Box)(({ theme }) => ({
    display: "flex",
    height: "66px",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.core.grey._20,
    padding: theme.spacing(3),
}));

export const ModelImage = styled("img")(() => ({
    width: "100%",
    height: "100%",
    objectFit: "contain",
}));

export const TextContent = styled(Box)(({ theme }) => ({
    display: "flex",
    height: "48px",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.core.white,
    padding: theme.spacing(2),
}));

export const TypographyWithEllipsis = styled(Typography)(({ theme }) => ({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: "100%",
}));
